export const GlobalVariableValues = {
    GradingOutputAbove50:30,
    GradingOutputBelow50:33,
    companyId:31,
    assetmanagementcompanyId:9,
    salemoduleId:4,
    warehouseModuleId:1,
    hrmsModuleId:2,
    procurementmoduleId:5,
    logisticsmoduleId:6,
    downtimeModuleId:12,
    supplierPortaModuleId:13,
    rmProcurementmoduleId:14,
    assetManagementmoduleId:11,
    canteenmanagementmoduleId:16,
    AllModuleId:15,
    vistorManagementId:18,
    productionModuleId : 20,
    enquiryModuleId:34,
    cookingId: 1,    //to get the boiler fuel cost for the cooked products in cost sheet
    destinationId:31, //for MTS orders taking fixed destination (plant destination)
    boxWeight: 1.8,  // to calculate total reweighment qty
    NAbrandId : 25, // to get N/A brand info in enquiry product form
    productionVersion : 'V2' ,  // V1 for sandya aqua , V2 for BMR functionality
    countryIdForFrozenWeigth : 8,  // For china frozen weight should not be required
    incentiveFixedVariable : 6.5   //Fixed variable to calculate incentive percentage in cost sheet
}